import React, { useContext, useMemo, useState } from "react";
import styles from "./index.module.scss";
import UserAvatar from "../../../Components/UserAvatar";
import Space from "components/Space";
import Replies from "../Replies";
import { Icon, Tooltip } from "antd";
import classNames from "classnames";
import { LikeOrNot } from "../LikeOrNot";
import { AnswerContent, DiscussContent } from "../../context";
import { getFriendlyTime, isTrue } from "../../../../../Utils/filter";
import { getReplyCount, ReplyItemData, SpeakerType } from "API/discuss";
import { AnswerMange } from "./Components/AnswerMange";
import moment from "moment/moment";

interface AnswerProps {
    index: number;
    data: ReplyItemData;
}

export default function Answer({ index, data }: AnswerProps) {
    const [showReply, setShowReply] = useState(false);
    const isTeacher = data.speakerType === SpeakerType.Teacher;

    const replyCount = useMemo(
        () => getReplyCount(data.currentFloorReplies || []),
        [data]
    );
    const { isDead, discussDetail } = useContext(DiscussContent);

    return (
        <AnswerContent.Provider value={{ answerData: data, replyCount }}>
            <div className={styles.root}>
                <div className={styles.header}>
                    <div className={styles.user}>
                        {isTrue(discussDetail?.showStudentName) && (
                            <UserAvatar
                                className={styles.avatar}
                                size={38}
                                isTeacher={isTeacher}
                                userNo={data.speakerNo}
                                userName={data.speakerName}
                            />
                        )}

                        <div className={styles.userInfo}>
                            {isTrue(discussDetail?.showStudentName) && (
                                <div className={styles.userName}>
                                    {data.speakerName}
                                    {isTeacher && (
                                        <span className={styles.teacher}>
                                            老师
                                        </span>
                                    )}
                                </div>
                            )}
                            <div className={styles.time}>
                                {getFriendlyTime(data.createTime)}
                                {data.updateTime !== data.createTime && (
                                    <Tooltip
                                        title={`重新编辑时间：${moment(
                                            data.updateTime
                                        ).format("YYYY-MM-DD HH:mm:ss")}`}
                                        style={{ marginLeft: 10 }}>
                                        <Icon
                                            type="info-circle"
                                            className={styles.tips}
                                        />
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className={styles.status}>
                        <Space className={styles.floor}>
                            {isTrue(data.isTop) && (
                                <Icon
                                    type="crown"
                                    className={styles.clown}
                                    title="置顶"
                                />
                            )}

                            <span>第 {index + 1} 楼</span>
                        </Space>
                    </div>
                </div>

                <div
                    dangerouslySetInnerHTML={{ __html: data.replyContent }}
                    className={classNames(styles.content, {
                        [styles.blocked]: !isTrue(data.canShow)
                    })}
                />

                <Space className={styles.footer} size={15}>
                    <LikeOrNot answerData={data} />

                    {isTrue(discussDetail?.canMutualReplay) && (
                        <button
                            className={styles.btn}
                            onClick={() => setShowReply(!showReply)}>
                            {showReply
                                ? "收起回复"
                                : `${
                                      data.currentFloorReplies?.length
                                          ? `${replyCount}条回复`
                                          : "回复"
                                  }`}
                        </button>
                    )}

                    {isTrue(data.canEdit) &&
                        !isDead &&
                        !isTrue(data.delStatus) && (
                            <AnswerMange editUuid={data.uuid} />
                        )}
                </Space>

                {showReply && <Replies data={data.currentFloorReplies || []} />}
            </div>
        </AnswerContent.Provider>
    );
}
